import axios from "axios";

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const adminApi = axios.create({ baseURL: `${BASE}/admin`, withCredentials: true, timeout: 60000 });
export const authApi = axios.create({ baseURL: `${BASE}/auth`, withCredentials: true, timeout: 20000 });

export function apiError(err, fallback = "Something went wrong. Please try again.") {
  const detail = err?.response?.data?.detail;
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail)) {
    const msg = detail.map((e) => (e && typeof e.msg === "string" ? e.msg.replace(/^Value error, /, "") : "")).filter(Boolean).join(" ");
    if (msg) return msg;
  }
  return fallback;
}

export const formatDate = (iso) => {
  if (!iso) return "—";
  try {
    return new Date(iso).toLocaleDateString("en-SG", { day: "numeric", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const STATUS_META = {
  available: { label: "Available", dot: "bg-emerald-400" },
  under_offer: { label: "Under Offer", dot: "bg-amber-400" },
  sold: { label: "Sold", dot: "bg-slate-400" },
  draft: { label: "Draft", dot: "bg-white/40" },
  archived: { label: "Archived", dot: "bg-white/20" },
};

export const StatusBadge = ({ status }) => {
  const meta = STATUS_META[status] || STATUS_META.draft;
  return (
    <span className="inline-flex items-center gap-2 border border-ivory/20 px-2.5 py-1 text-[0.65rem] font-semibold uppercase tracking-[0.15em] text-ivory">
      <span className={`h-1.5 w-1.5 rounded-full ${meta.dot}`} />
      {meta.label}
    </span>
  );
};
